export type SkillCategory =
  | 'Industry Knowledge'
  | 'Interpersonal Skills'
  | 'Business Strategy'

export interface Skill {
  name: string
  category: SkillCategory
  endorsements: string | null
  notes: string[]
}

export const skillCategories: Array<'All' | SkillCategory> = [
  'All',
  'Industry Knowledge',
  'Interpersonal Skills',
  'Business Strategy',
]

export const skills: Skill[] = [
  {
    name: 'Defense Industry',
    category: 'Industry Knowledge',
    endorsements: '1',
    notes: ['4 experiences at United States Department of the Navy and 1 other company'],
  },
  {
    name: 'Teaching',
    category: 'Interpersonal Skills',
    endorsements: '1',
    notes: ['President & CEO at Blue-Water Strategies, LLC'],
  },
  {
    name: 'Public Administration',
    category: 'Industry Knowledge',
    endorsements: null,
    notes: ['7 experiences at State of Oklahoma and 6 other companies'],
  },
  {
    name: 'Political Science',
    category: 'Industry Knowledge',
    endorsements: null,
    notes: ['President & CEO at Blue-Water Strategies, LLC'],
  },
  {
    name: 'Global Issues',
    category: 'Industry Knowledge',
    endorsements: null,
    notes: ['6 experiences at United States Department of the Navy and 3 other companies'],
  },
  {
    name: 'American Government',
    category: 'Industry Knowledge',
    endorsements: null,
    notes: ['President & CEO at Blue-Water Strategies, LLC'],
  },
  {
    name: 'Crisis Communications',
    category: 'Interpersonal Skills',
    endorsements: '99+',
    notes: [
      'Endorsed by Vic Beck and 11 others who are highly skilled at this',
      'Endorsed by 5 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Public Relations',
    category: 'Interpersonal Skills',
    endorsements: '99+',
    notes: [
      'Endorsed by Jon Lundberg and 14 others who are highly skilled at this',
      'Endorsed by 2 colleagues at United States Department of the Navy',
    ],
  },
  {
    name: 'Personnel Management',
    category: 'Business Strategy',
    endorsements: '10',
    notes: [],
  },
  {
    name: 'System Administration',
    category: 'Industry Knowledge',
    endorsements: '8',
    notes: [],
  },
  {
    name: 'Strategic Communications',
    category: 'Business Strategy',
    endorsements: '99+',
    notes: [
      'Endorsed by Vic Beck and 30 others who are highly skilled at this',
      'Endorsed by 6 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Military',
    category: 'Industry Knowledge',
    endorsements: '84',
    notes: [
      'Endorsed by General David H. Petraeus, US Army (Ret.) and 10 others who are highly skilled at this',
      'Endorsed by 2 colleagues at United States Department of the Navy',
    ],
  },
  {
    name: 'Crisis Management',
    category: 'Business Strategy',
    endorsements: null,
    notes: [
      '2 experiences at State of Oklahoma and 1 other company',
      'Endorsed by Hal Pittman, MBA, MA and 11 others who are highly skilled at this',
      'Endorsed by 3 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Media Relations',
    category: 'Interpersonal Skills',
    endorsements: '99+',
    notes: [
      'Endorsed by Cappy Surette and 17 others who are highly skilled at this',
      'Endorsed by 6 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Security Clearance',
    category: 'Industry Knowledge',
    endorsements: '32',
    notes: [],
  },
  {
    name: 'DoD',
    category: 'Industry Knowledge',
    endorsements: '60',
    notes: [
      'Endorsed by James Hutton and 2 others who are highly skilled at this',
      'Endorsed by 2 colleagues at United States Department of the Navy',
    ],
  },
  {
    name: 'Government',
    category: 'Industry Knowledge',
    endorsements: '99+',
    notes: [
      'Endorsed by General David H. Petraeus, US Army (Ret.) and 31 others who are highly skilled at this',
      'Endorsed by 2 colleagues at United States Department of the Navy',
    ],
  },
  {
    name: 'Public Affairs',
    category: 'Interpersonal Skills',
    endorsements: '62',
    notes: [
      'Endorsed by Cappy Surette and 11 others who are highly skilled at this',
      'Endorsed by 5 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Spokesperson',
    category: 'Interpersonal Skills',
    endorsements: '39',
    notes: ['Endorsed by Ed "Disco" B. and 3 others who are highly skilled at this'],
  },
  {
    name: 'Public Speaking',
    category: 'Interpersonal Skills',
    endorsements: '66',
    notes: [
      'President & CEO at Blue-Water Strategies, LLC',
      'Endorsed by 2 colleagues at General Dynamics Information Technology',
    ],
  },
  {
    name: 'Navy',
    category: 'Industry Knowledge',
    endorsements: '27',
    notes: ['Endorsed by Jeff Richter who is highly skilled at this'],
  },
  {
    name: 'Government Liasioning',
    category: 'Industry Knowledge',
    endorsements: '8',
    notes: [],
  },
  {
    name: 'Policy',
    category: 'Business Strategy',
    endorsements: '22',
    notes: ['Endorsed by Todd Pauley, Esq. and 1 other who is highly skilled at this'],
  },
  {
    name: 'Command',
    category: 'Business Strategy',
    endorsements: '36',
    notes: [
      'Endorsed by General David H. Petraeus, US Army (Ret.) and 1 other who is highly skilled at this',
      'Endorsed by 2 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Press Releases',
    category: 'Interpersonal Skills',
    endorsements: '16',
    notes: [
      'Endorsed by Scot Cregan and 1 other who is highly skilled at this',
      'Endorsed by 2 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Training',
    category: 'Interpersonal Skills',
    endorsements: '45',
    notes: [
      'Endorsed by Jeffrey Lee, MSIT, CSM, ITILv4, LSSYB and 4 others who are highly skilled at this',
      'Endorsed by 5 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Leadership',
    category: 'Business Strategy',
    endorsements: null,
    notes: [
      'Interim Commissioner, Oklahoma Department of Mental Health & Substance Abuse at State of Oklahoma',
      'Endorsed by Bruce Litchfield and 5 others who are highly skilled at this',
      'Endorsed by 7 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Community Development',
    category: 'Interpersonal Skills',
    endorsements: '21',
    notes: [
      'Endorsed by Shane David Jett who is highly skilled at this',
      'Endorsed by 3 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Fundraising',
    category: 'Business Strategy',
    endorsements: '19',
    notes: ['Endorsed by Todd Pauley, Esq. who is highly skilled at this'],
  },
  {
    name: 'Military Operations',
    category: 'Industry Knowledge',
    endorsements: '15',
    notes: [],
  },
  {
    name: 'Communication Training',
    category: 'Interpersonal Skills',
    endorsements: '12',
    notes: [],
  },
  {
    name: 'Defense',
    category: 'Industry Knowledge',
    endorsements: '47',
    notes: [
      'Endorsed by Phil G. Busey and 2 others who are highly skilled at this',
      'Endorsed by 2 colleagues at General Dynamics Information Technology',
    ],
  },
  {
    name: 'National Security',
    category: 'Industry Knowledge',
    endorsements: '79',
    notes: [
      'Endorsed by Lamont Woody and 3 others who are highly skilled at this',
      'Endorsed by 7 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Communications Planning',
    category: 'Business Strategy',
    endorsements: '32',
    notes: [
      'Endorsed by James Hutton and 2 others who are highly skilled at this',
      'Endorsed by 2 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Military Experience',
    category: 'Industry Knowledge',
    endorsements: '15',
    notes: ['Endorsed by David W. and 1 other who is highly skilled at this'],
  },
  {
    name: 'Strategic Planning',
    category: 'Business Strategy',
    endorsements: '74',
    notes: [
      'Endorsed by Bruce Litchfield and 1 other who is highly skilled at this',
      'Endorsed by 4 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Internal Communications',
    category: 'Interpersonal Skills',
    endorsements: '17',
    notes: ['Endorsed by Ron Steiner, APR plus M and 2 others who are highly skilled at this'],
  },
  {
    name: 'Politics',
    category: 'Industry Knowledge',
    endorsements: '18',
    notes: ['Endorsed by Todd Pauley, Esq. who is highly skilled at this'],
  },
  {
    name: 'Community Outreach',
    category: 'Interpersonal Skills',
    endorsements: '20',
    notes: ['Endorsed by 2 colleagues at United States Department of War'],
  },
  {
    name: 'Speech Writing',
    category: 'Interpersonal Skills',
    endorsements: '13',
    notes: [],
  },
  {
    name: 'Organizational Leadership',
    category: 'Business Strategy',
    endorsements: '20',
    notes: [
      'Executive Director at Oklahoma Department of Veterans Affairs',
      'Endorsed by Phil G. Busey and 2 others who are highly skilled at this',
    ],
  },
  {
    name: 'Nonprofits',
    category: 'Industry Knowledge',
    endorsements: '11',
    notes: ['Endorsed by Todd Pauley, Esq. who is highly skilled at this'],
  },
  {
    name: 'Corporate Communications',
    category: 'Business Strategy',
    endorsements: '17',
    notes: ['Endorsed by Hal Pittman, MBA, MA and 2 others who are highly skilled at this'],
  },
  {
    name: 'Project Planning',
    category: 'Business Strategy',
    endorsements: '13',
    notes: [],
  },
  {
    name: 'Proposal Writing',
    category: 'Business Strategy',
    endorsements: '15',
    notes: [],
  },
  {
    name: 'Management',
    category: 'Business Strategy',
    endorsements: '30',
    notes: [
      'Endorsed by General David H. Petraeus, US Army (Ret.) who is highly skilled at this',
      'Endorsed by 3 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Strategy',
    category: 'Business Strategy',
    endorsements: '55',
    notes: [
      'Endorsed by GLEN LATONA who is highly skilled at this',
      'Endorsed by 5 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Program Management',
    category: 'Business Strategy',
    endorsements: '34',
    notes: [
      'Endorsed by Phil G. Busey and 3 others who are highly skilled at this',
      'Endorsed by 2 colleagues at United States Department of War',
    ],
  },
  {
    name: 'Intelligence',
    category: 'Industry Knowledge',
    endorsements: '7',
    notes: [],
  },
  {
    name: 'Business Development',
    category: 'Business Strategy',
    endorsements: '5',
    notes: [],
  },
  {
    name: 'International Relations',
    category: 'Industry Knowledge',
    endorsements: '18',
    notes: [
      'Endorsed by Shane David Jett who is highly skilled at this',
      'Endorsed by 2 colleagues at United States Department of War',
    ],
  },
  { name: 'Security', category: 'Industry Knowledge', endorsements: '13', notes: [] },
  { name: 'Marketing', category: 'Business Strategy', endorsements: '20', notes: [] },
  { name: 'Messaging', category: 'Interpersonal Skills', endorsements: '7', notes: [] },
  { name: 'Entrepreneurship', category: 'Business Strategy', endorsements: '12', notes: [] },
  { name: 'Management Consulting', category: 'Business Strategy', endorsements: '8', notes: [] },
]
